import React, { useState } from 'react';
import { Ban, RefreshCw, AlertCircle } from 'lucide-react';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../../ui/dialog';

/** Tax-style Cancel Mail-Away modal — reason required (min 5 chars). */
export const MailAwayCancelModal = ({ open, targetName, loading, onConfirm, onClose, testIdPrefix = 'mailaway' }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const submit = () => {
    if (reason.trim().length < 5) { setError('A cancellation reason (minimum 5 characters) is required.'); return; }
    setError('');
    onConfirm(reason.trim());
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v && !loading) onClose(); }}>
      <DialogContent className="sm:max-w-md" data-testid={`${testIdPrefix}-cancel-modal`}>
        <div className="flex items-center gap-3">
          <div className="p-2 bg-red-100 rounded-full"><Ban size={20} className="text-red-600" /></div>
          <DialogTitle className="text-lg font-semibold text-gray-900">Cancel Mail-Away Request</DialogTitle>
        </div>
        <DialogDescription className="text-gray-600">
          Cancel the request to <strong>{targetName}</strong>? The record is kept in the history as cancelled.
        </DialogDescription>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Cancellation Reason <span className="text-red-500">*</span></label>
          <textarea value={reason} onChange={(e) => { setReason(e.target.value); setError(''); }} rows={3}
            className={`w-full px-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 ${error ? 'border-red-400' : 'border-gray-300'}`}
            placeholder="Why is this request being cancelled?" data-testid={`${testIdPrefix}-cancel-reason`} />
          {error && <p className="mt-1.5 text-sm text-red-600 flex items-center gap-1"><AlertCircle size={14} />{error}</p>}
        </div>
        <div className="flex items-center gap-3">
          <Button onClick={submit} disabled={loading} className="flex-1 bg-red-600 hover:bg-red-700" data-testid={`${testIdPrefix}-cancel-confirm`}>
            {loading ? <><RefreshCw size={16} className="mr-2 animate-spin" />Cancelling...</> : <><Ban size={16} className="mr-2" />Cancel Request</>}
          </Button>
          <Button variant="outline" onClick={onClose} disabled={loading} data-testid={`${testIdPrefix}-cancel-dismiss`}>Keep Request</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MailAwayCancelModal;
